module.exports = __webpack_public_path__ + "static/media/SnowfallEffect.d.ts.55f003d9.map";